import React from "react";
import Item from "./Item";

export default function List ({ users = [], type }) {    
    return (
        <div style={{ ...style.list }}>
            {users.map((user, idx) => <Item key={idx.toString()} user={user} errorItem={type === 'errorUsers'}/>)}
            {users.length === 0 && 
                <span style={{ alignSelf: 'center' }}>{"אין משתמשים להציג"}</span>}
        </div>
    )
}

const style = {
    list: {
        display: 'flex',
        flexDirection: 'column',
        padding: '30px 10px',
        backgroundColor: 'white',
        borderRadius: '10px',
        maxHeight: '600px',
        overflow: 'scroll'
    }
}